/**
 * KitUnitConversionUtils
 * All utilities related to converting units.
 *
 * Examples:
 * - Fahrenheit to Celsius
 * - Celsius to Fahrenheit
 * - Miles to kilometers
 * - Kilometers to miles
 * - Liters to Gallons
 * - Gallons to Liters
 */

export function usesMetricUnits(countryCode: string) {
  return !['US'].includes(countryCode);
}

export const imperialUnits = {
  distance: 'miles',
  temperature: 'fahrenheit',
  volume: 'gallons',
};

export const metricUnits = {
  distance: 'kilometers',
  temperature: 'celsius',
  volume: 'liters',
};

export interface LocalizedUnits {
  distance: string;
  temperature: string;
  volume: string;
}

/**
 * User preferences for distance, temperature, and volume.
 * If the userPreferenceOverrides argument is passed, then it will override any metric or imperial unit preference defaults
 *
 * @param overrides
 * @param locale
 * @returns
 */
export const getUnitPreferences = (
  countryCode: string,
  userPreferenceOverrides: Partial<LocalizedUnits> = {}
): LocalizedUnits => {
  if (usesMetricUnits(countryCode)) {
    return { ...metricUnits, ...userPreferenceOverrides };
  }

  return { ...imperialUnits, ...userPreferenceOverrides };
};
